import type {ReactElement} from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import {EditorViewport} from '@EmailMakerReact/email-maker-react.types';
import {
  CONTROL_HEIGHT,
  EXPORT_WIDTH,
  FILE_WIDTH,
  HELP_WIDTH,
  MOBILE_ICON_BRICK,
  PREVIEW_WIDTH,
  PUBLISH_OPTIONS_WIDTH,
  SAVE_WIDTH,
  SEND_WIDTH,
  UNDO_REDO_WIDTH,
} from './nav-loading-skeleton.types';
import type {NavLoadingSkeletonProps} from './nav-loading-skeleton.types';
import styles from './nav-loading-skeleton.module.scss';

export function NavLoadingSkeleton({editorViewport}: NavLoadingSkeletonProps): ReactElement {
  if (editorViewport === EditorViewport.MOBILE) {
    return renderMobileSkeleton();
  }
  return renderDesktopSkeleton();
}

function renderDesktopSkeleton(): ReactElement {
  return (
    <div aria-hidden className={styles.cluster}>
      <SkeletonBrick height={CONTROL_HEIGHT} width={FILE_WIDTH} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={CONTROL_HEIGHT} width={UNDO_REDO_WIDTH} theme={SkeletonBrickTheme.DARK} />
      <div className={styles.spacer} />
      <SkeletonBrick height={CONTROL_HEIGHT} width={SAVE_WIDTH} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={CONTROL_HEIGHT} width={HELP_WIDTH} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={CONTROL_HEIGHT} width={PREVIEW_WIDTH} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={CONTROL_HEIGHT} width={EXPORT_WIDTH} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={CONTROL_HEIGHT} width={SEND_WIDTH} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={CONTROL_HEIGHT} width={PUBLISH_OPTIONS_WIDTH} theme={SkeletonBrickTheme.DARK} />
    </div>
  );
}

function renderMobileSkeleton(): ReactElement {
  return (
    <div aria-hidden className={styles.cluster}>
      <SkeletonBrick height={MOBILE_ICON_BRICK} width={MOBILE_ICON_BRICK} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={MOBILE_ICON_BRICK} width={MOBILE_ICON_BRICK} theme={SkeletonBrickTheme.DARK} />
      <div className={styles.spacer} />
      <SkeletonBrick height={MOBILE_ICON_BRICK} width={MOBILE_ICON_BRICK} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={MOBILE_ICON_BRICK} width={MOBILE_ICON_BRICK} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={MOBILE_ICON_BRICK} width={MOBILE_ICON_BRICK} theme={SkeletonBrickTheme.DARK} />
      <SkeletonBrick height={MOBILE_ICON_BRICK} width={MOBILE_ICON_BRICK} theme={SkeletonBrickTheme.DARK} />
    </div>
  );
}
